import { render } from "./ModalFilterTransaction.vue?vue&type=template&id=38c7cd9d"
import script from "./ModalFilterTransaction.vue?vue&type=script&lang=js"
export * from "./ModalFilterTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__